import { Globe } from "lucide-react";
import { flagCodes, flagUrl, flagUrl2x } from "@/lib/flags";

export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1.5 text-sm">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function fmt(n) {
  if (n === null || n === undefined) return "0";
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return (n / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (abs >= 1_000) return (n / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return n.toLocaleString();
}

export function money(n) {
  const v = Number(n) || 0;
  return "$" + v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function LangFlags({ language, size = "sm", showLabel = false, className = "" }) {
  const codes = flagCodes(language);
  const h = size === "lg" ? "h-4" : "h-3";
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} title={language} data-testid="lang-flags">
      {codes.length === 0 ? (
        <Globe className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} />
      ) : (
        codes.map((c) => (
          <img
            key={c}
            src={flagUrl(c)}
            srcSet={`${flagUrl(c)} 1x, ${flagUrl2x(c)} 2x`}
            alt={c}
            className={`${h} w-auto rounded-[2px] shadow-sm ring-1 ring-black/20 object-cover`}
          />
        ))
      )}
      {showLabel && <span>{language}</span>}
    </span>
  );
}
